import * as CalendarActions from '../actions/calendar';
import calendarEventStatus from '../utils/calendarEventStatus';
import { reducer } from './reducerUtils';

const initialState = {
  fetchingCalendarEvent: false,
  isCalendarEventSaved: false,
  resyncJobId: false,
  recentRecords: [],
  listViews: [],
  selectedRecord: null,
  presave: false,
  isComposingEvent: false,
  selectedOrganizer: {},
  multipleMatchedOrganizers: {},
  multipleMatchedContacts: {},
  selectedContacts: {},
  isAssociatingAttendee: false,
  contactListObject: {},
  salesforceContactMap: {},
  eventAttendees: {}, // from the Outlook Calendar Event
  savedAttendees: [], // from our backend
  eventSubject: '',
  eventStart: '',
  eventEnd: '',
  eventLocation: '',
  eventRecurrence: null,
  eventAllDay: false,
  selectedRecordChange: false,
  attendeeChange: false,
  multiMatchAttendeeFixed: false,
  eventId: null,
  eventStatus: null,
  salesforceEventId: null,
  addingAttendee: false,
  attendeesToAdd: {},
  isMissingContacts: false,
  isSelectingRecord: false,
  attendeeBannerToggle: true,
  isPrivateEventSF: false,
  syncDisabled: false,
  isCalendarUser: false,
  delegateError: false,
};

export default reducer({
  [CalendarActions.CALENDAR_EVENT_SAVED_STATUS]: (state, action) => ({
    ...state,
    isCalendarEventSaved: action.savedStatus,
    fetchingCalendarEvent: false,
    recentRecords: action.recentRecords,
    listViews: action.listViews,
    selectedRecord: action.calendarEvent?.salesforceRelatedToObject ? { ...action.calendarEvent?.salesforceRelatedToObject?.displayFields, type: action.calendarEvent?.relatedToApiName, Id: action.calendarEvent.id } : null,
    eventStatus: action.eventStatus,
  }),
  [CalendarActions.COMPOSING_EVENT]: (state, { eventId }) => ({
    ...state,
    eventId: eventId || null,
    isComposingEvent: true,
  }),
  [CalendarActions.EVENT_LOADED]: (state, { eventId }) => ({
    ...state,
    eventId,
    isComposingEvent: false,
  }),
  [CalendarActions.SELECT_ORGANIZER]: (state, { contact }) => ({
    ...state,
    isAssociatingAttendee: false,
    contactListObject: {},
    selectedOrganizer: contact,
    multipleMatchedOrganizers: {},
  }),
  [CalendarActions.CANCEL_SELECT_CONTACT]: (state) => ({
    ...state,
    isAssociatingAttendee: false,
    contactListObject: {},
  }),
  [CalendarActions.SET_MATCHED_ORGANIZERS]: (state, { contactListMap }) => ({
    ...state,
    multipleMatchedOrganizers: contactListMap,
  }),
  [CalendarActions.SET_SELECTED_CONTACTS]: (state, { contactListMap }) => ({
    ...state,
    selectedContacts: contactListMap,
  }),
  [CalendarActions.SET_MATCHED_CONTACTS]: (state, { contactListMap }) => ({
    ...state,
    multipleMatchedContacts: contactListMap,
  }),
  [CalendarActions.ASSOCIATE_ATTENDEE]: (state, { contactListObject }) => ({
    ...state,
    isAssociatingAttendee: true,
    contactListObject,
  }),
  [CalendarActions.SELECTED_RECORD]: (state, { selectedRecord }) => ({
    ...state,
    selectedRecordChange: true,
    selectedRecord,
  }),
  [CalendarActions.DESELECT_RECORD]: (state) => ({
    ...state,
    selectedRecordChange: true,
    selectedRecord: null,
  }),
  [CalendarActions.SET_EVENT_SUBJECT]: (state, action) => ({
    ...state,
    eventSubject: action.eventSubject,
  }),
  [CalendarActions.SET_EVENT_START]: (state, action) => ({
    ...state,
    eventStart: action.eventStart,
  }),
  [CalendarActions.SET_EVENT_END]: (state, action) => ({
    ...state,
    eventEnd: action.eventEnd,
  }),
  [CalendarActions.SET_EVENT_LOCATION]: (state, action) => ({
    ...state,
    eventLocation: action.eventLocation,
  }),
  [CalendarActions.SET_EVENT_RECURRENCE]: (state, action) => ({
    ...state,
    eventRecurrence: action.eventRecurrence,
  }),
  [CalendarActions.SET_EVENT_ATTENDEES]: (state, action) => ({
    ...state,
    eventAttendees: action.eventAttendees,
  }),
  [CalendarActions.SET_EVENT_ALL_DAY]: (state, action) => ({
    ...state,
    eventAllDay: action.eventAllDay,
  }),
  [CalendarActions.ATTENDEE_CHANGE]: (state) => ({
    ...state,
    attendeeChange: true,
  }),
  [CalendarActions.MULTI_MATCH_ATTENDEE_FIXED]: (state) => ({
    ...state,
    multiMatchAttendeeFixed: true,
  }),
  [CalendarActions.EVENT_PRESAVE]: (state, { calendarEvent }) => ({
    ...state,
    presave: true,
    isCalendarEventSaved: true,
    selectedRecord: calendarEvent?.salesforceRelatedToObject ? { ...calendarEvent?.salesforceRelatedToObject?.displayFields, type: calendarEvent?.relatedToApiName, Id: calendarEvent.id } : state.selectedRecord,
    eventStatus: calendarEventStatus.preSaved,
    attendeeChange: false,
    selectedRecordChange: false,
  }),
  [CalendarActions.EVENT_SAVED]: (state) => ({
    ...state,
    isCalendarEventSaved: true,
    eventStatus: calendarEventStatus.saving,
    attendeeChange: false,
    selectedRecordChange: false,
  }),
  [CalendarActions.SET_EVENT_STATUS]: (state, { eventStatus }) => ({
    ...state,
    eventStatus,
  }),
  [CalendarActions.SET_SALESFORCE_CONTACT_MAP]: (state, { contactMap }) => ({
    ...state,
    salesforceContactMap: contactMap,
  }),
  [CalendarActions.SET_SAVED_ATTENDEES]: (state, { attendees }) => ({
    ...state,
    savedAttendees: attendees,
  }),
  [CalendarActions.SET_SALESFORCE_EVENT_ID]: (state, { eventId }) => ({
    ...state,
    salesforceEventId: eventId,
  }),
  [CalendarActions.ADDING_ATTENDEE]: (state, { isAdding }) => ({
    ...state,
    addingAttendee: isAdding,
  }),
  [CalendarActions.SET_ATTENDEES_TO_ADD]: (state, { attendeesToAdd }) => ({
    ...state,
    attendeesToAdd,
  }),
  [CalendarActions.IS_MISSING_CONTACTS]: (state, { isMissingContacts }) => ({
    ...state,
    isMissingContacts,
  }),
  [CalendarActions.IS_SELECTING_RECORD]: (state, { isSelectingRecord }) => ({
    ...state,
    isSelectingRecord,
  }),
  [CalendarActions.SET_ATTENDEE_BANNER]: (state, { attendeeBannerToggle }) => ({
    ...state,
    attendeeBannerToggle,
  }),
  [CalendarActions.SYNC_DISABLED]: (state, { syncDisabled }) => ({
    ...state,
    syncDisabled,
  }),
  [CalendarActions.UNSYNC_EVENT]: (state) => ({
    ...state,
    eventStatus: null,
    isCalendarEventSaved: false,

  }),
  [CalendarActions.IS_PRIVATE_EVENT_SF]: (state, { isPrivateEventSF }) => ({
    ...state,
    isPrivateEventSF,
  }),
  [CalendarActions.IS_CALENDAR_USER]: (state, { isCalendarUser }) => ({
    ...state,
    isCalendarUser,
  }),
  [CalendarActions.DELEGATE_ERROR]: (state, { delegateError }) => ({
    ...state,
    delegateError,
  }),
  [CalendarActions.SET_OWNER_FOR_DELEGATED_CALENDAR]: (state, { ownerForDelegatedCalendar }) => ({
    ...state,
    ownerForDelegatedCalendar,
  }),
  [CalendarActions.SET_RESYNC_JOB_ID]: (state, { resyncJobId }) => ({
    ...state,
    resyncJobId,
  }),
}, initialState);
